/**
 * COLESCOMEX isotipo geometry, viewBox 0 0 200 200, ring centred at (100, 100).
 *
 * PROVENANCE: no vector master (.svg/.eps) exists in the repository (brand/logo/README §4).
 * These paths were reconstructed from brand/logo/propuesta-evolucion-logotipo-v2.png
 * (Opción 2 · recomendada) by contour tracing and geometric fitting:
 *   - C ring: outer circle r=100 + eccentric inner circle r=68.36, two angled cuts;
 *   - inner pieces: circular outer arcs + S-wave edges, separated by parallel diagonal cuts.
 * Replace with the approved vector master when it is delivered; every consumer reads
 * from this module, so the swap is a single-file change.
 */
export const MARK_VIEWBOX = '0 0 200 200';
export const MARK_CENTER = { x: 100, y: 100 } as const;

export const MARK_PATHS = {
  ring: 'M180.99 41.34 A100 100 0 1 0 188.45 146.66 L173.43 133.18 A68.36 68.36 0 1 1 156.74 67.64 Z',
  innerTop: 'M148.4 76.8 A54.3 54.3 0 0 0 57.4 129.9 C62.5 122.6 77.4 102 86.3 97.6 C97 91.2 114 90.8 125.5 99.8 L148.4 76.8 Z',
  innerBottom: 'M154.2 115 C143 112.4 128 117.8 118.2 126 C113 130.6 97.5 129.6 90.8 125.3 L71.2 147.8 A52.5 52.5 0 0 0 154.2 115 Z',
} as const;

/** Outer edge of the C used by the signal pulse (same circle, same opening as the ring). */
export const RING_SIGNAL_PATH = 'M180.99 41.34 A100 100 0 1 0 188.45 146.66';

export const WORDMARK = { primary: 'COLES', secondary: 'COMEX', descriptor: 'PROCUREMENT · SUPPLY CHAIN · COMERCIO EXTERIOR' } as const;

export type MarkTone = 'light' | 'dark';
/** Fills per surface. Light = on white/ice. Dark = negative version on navy. Brand palette only. */
export const MARK_TONES = {
  light: {
    ring: ['#0a2d56', '#0b4a8c', '#0066b3'], innerTop: ['#00b4db', '#0096cf'], innerBottom: ['#0a2d56', '#0066b3'],
    primary: '#0a2d56', secondary: '#0066b3', descriptor: '#273642',
  },
  dark: {
    ring: ['#ffffff', '#eef5f8', '#c9dbe6'], innerTop: ['#00b4db', '#36c3e3'], innerBottom: ['#0066b3', '#00b4db'],
    primary: '#ffffff', secondary: '#00b4db', descriptor: 'rgba(238,245,248,0.74)',
  },
} as const;
